/*!
 ╔══════════════════════════════════════════════════════════════════╗
 ║  ORYN EFFECTS LIBRARY  —  oryn-effects.js  v1.0                 ║
 ║  Drop into any Shopify theme.  Pair with oryn-effects.css        ║
 ╚══════════════════════════════════════════════════════════════════╝

  QUICK START
  ───────────
  1. Upload oryn-effects.css and oryn-effects.js to theme Assets
  2. In layout/theme.liquid <head>:
       {{ 'oryn-effects.css' | asset_url | stylesheet_tag }}
  3. Before </body>:
       <script src="{{ 'oryn-effects.js' | asset_url }}" defer></script>
  4. Add data attributes / classes to your HTML (see each section below)

  CONFIGURATION
  ─────────────
  Set window.ORYN_CONFIG before this script loads to override defaults:
  <script>
    window.ORYN_CONFIG = {
      cursor:     true,   // custom cursor (desktop only)
      reveal:     true,   // scroll-reveal animations
      parallax:   true,   // parallax on [data-oryn-parallax]
      counters:   true,   // animated number counters
      tilt:       true,   // 3D card tilt on hover
      stickyNav:  true,   // sticky nav class toggle
      loader:     true,   // loading screen
      accordion:  true,   // FAQ accordion
    };
  </script>
*/

(function () {
  'use strict';

  var CFG = Object.assign({
    cursor: true, reveal: true, parallax: true,
    counters: true, tilt: true, stickyNav: true,
    loader: true, accordion: true
  }, window.ORYN_CONFIG || {});

  /* ──────────────────────────────────────
     1. CUSTOM CURSOR
     Requires: <div id="oryn-cursor"><div class="oc-dot"></div><div class="oc-ring"></div></div>
     body { cursor: none; }
  ────────────────────────────────────── */
  function initCursor() {
    if (!CFG.cursor) return;
    var isTouchDevice = window.matchMedia('(pointer:coarse)').matches;
    var curEl = document.getElementById('oryn-cursor');
    if (!curEl || isTouchDevice) {
      if (curEl) curEl.style.display = 'none';
      return;
    }
    var dot  = curEl.querySelector('.oc-dot');
    var ring = curEl.querySelector('.oc-ring');
    var mx=0, my=0, rx=0, ry=0;

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    });
    (function tick() {
      rx += (mx - rx) * 0.09; ry += (my - ry) * 0.09;
      ring.style.left = Math.round(rx * 10)/10 + 'px';
      ring.style.top  = Math.round(ry * 10)/10 + 'px';
      requestAnimationFrame(tick);
    })();

    // Hover state on interactive elements
    document.querySelectorAll('a,button,[role="button"]').forEach(function(el) {
      el.addEventListener('mouseenter', function() { curEl.classList.add('oryn-cursor--hover'); });
      el.addEventListener('mouseleave', function() { curEl.classList.remove('oryn-cursor--hover'); });
    });
    document.addEventListener('mouseleave', function() { curEl.classList.add('oryn-cursor--hidden'); });
    document.addEventListener('mouseenter', function() { curEl.classList.remove('oryn-cursor--hidden'); });
  }

  /* ──────────────────────────────────────
     2. SCROLL REVEAL
     Classes: .oryn-fade-up  .oryn-fade-left  .oryn-fade-right
              .oryn-fade-scale  .oryn-clip-reveal
     Delay:   .oryn-d1 → .oryn-d6
     JS adds .oryn-visible when element enters viewport.
  ────────────────────────────────────── */
  function initReveal() {
    if (!CFG.reveal) return;
    var sel = '.oryn-fade-up,.oryn-fade-left,.oryn-fade-right,.oryn-fade-scale,.oryn-clip-reveal';
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('oryn-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -55px 0px' });

    document.querySelectorAll(sel).forEach(function(el) { obs.observe(el); });
  }

  /* ──────────────────────────────────────
     3. PARALLAX
     Add data-oryn-parallax="-0.15" to any element.
     Negative = moves up slower than scroll (depth effect).
     Positive = moves down faster (layered scroll).
  ────────────────────────────────────── */
  function initParallax() {
    if (!CFG.parallax) return;
    var els = Array.from(document.querySelectorAll('[data-oryn-parallax]'));
    if (!els.length) return;

    function run() {
      var sy = window.scrollY, vh = window.innerHeight;
      els.forEach(function(el) {
        var speed = parseFloat(el.dataset.orynParallax || '-0.15');
        var rect  = el.parentElement.getBoundingClientRect();
        var mid   = rect.top + rect.height / 2 - vh / 2;
        el.style.transform = 'translateY(' + (mid * speed).toFixed(2) + 'px)';
      });
    }
    window.addEventListener('scroll', run, { passive: true });
    run();
  }

  /* ──────────────────────────────────────
     4. ANIMATED COUNTERS
     Add data-oryn-count="200" to any element.
     Optional data-oryn-suffix="+" or "%"
     Triggers when element scrolls into view.
  ────────────────────────────────────── */
  function initCounters() {
    if (!CFG.counters) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;
        var el     = e.target;
        var target = parseFloat(el.dataset.orynCount);
        var suffix = el.dataset.orynSuffix || '';
        var start; var dur = 1500;
        (function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.floor(eased * target) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = target + suffix;
        })(0);
        obs.unobserve(el);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-oryn-count]').forEach(function(el) { obs.observe(el); });
  }

  /* ──────────────────────────────────────
     5. CARD 3D TILT
     Add class .oryn-tilt to any card/element.
     Tilts toward cursor on hover. Auto-resets on mouse leave.
  ────────────────────────────────────── */
  function initTilt() {
    if (!CFG.tilt) return;
    document.querySelectorAll('.oryn-tilt').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width  - 0.5;
        var y = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transform  = 'perspective(1000px) rotateY('+( x*5)+'deg) rotateX('+(-y*5)+'deg) translateZ(8px)';
        card.style.transition = 'transform .05s';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform  = 'perspective(1000px) rotateY(0) rotateX(0) translateZ(0)';
        card.style.transition = 'transform .7s cubic-bezier(.23,1,.32,1)';
      });
    });
  }

  /* ──────────────────────────────────────
     6. STICKY NAV
     Add id="oryn-nav" to your <header>.
     Adds class .oryn-nav--stuck when scrolled > 60px.
     Style .oryn-nav--stuck in your CSS (see oryn-effects.css comments).
  ────────────────────────────────────── */
  function initStickyNav() {
    if (!CFG.stickyNav) return;
    var nav = document.getElementById('oryn-nav');
    if (!nav) return;
    window.addEventListener('scroll', function() {
      nav.classList.toggle('oryn-nav--stuck', window.scrollY > 60);
    }, { passive: true });
  }

  /* ──────────────────────────────────────
     7. LOADER
     Requires: <div id="oryn-loader">
                 <div class="oryn-loader__bar-wrap">
                   <div class="oryn-loader__bar" id="oryn-loader-bar"></div>
                 </div>
                 <div class="oryn-loader__num" id="oryn-loader-num">000</div>
               </div>
     Animates bar 0→100%, then fades out the loader div.
     Optional callback: window.ORYN_ON_LOADED = function() { ... }
  ────────────────────────────────────── */
  function initLoader() {
    if (!CFG.loader) return;
    var loader = document.getElementById('oryn-loader');
    var bar    = document.getElementById('oryn-loader-bar');
    var num    = document.getElementById('oryn-loader-num');
    if (!loader) return;

    var pct = 0;
    var tick = setInterval(function() {
      pct = Math.min(100, pct + Math.floor(Math.random() * 7) + 3);
      if (bar) bar.style.width = pct + '%';
      if (num) num.textContent = String(pct).padStart(3,'0');
      if (pct >= 100) {
        clearInterval(tick);
        setTimeout(function() {
          loader.classList.add('oryn-loader--out');
          setTimeout(function() {
            loader.style.display = 'none';
            if (typeof window.ORYN_ON_LOADED === 'function') window.ORYN_ON_LOADED();
          }, 600);
        }, 300);
      }
    }, 55);
  }

  /* ──────────────────────────────────────
     8. ACCORDION
     Requires class .oryn-accordion__btn with aria-controls="panel-id"
     and a matching <div class="oryn-accordion__panel" id="panel-id" hidden>
     See oryn-effects.css for full structure.
  ────────────────────────────────────── */
  function initAccordion() {
    if (!CFG.accordion) return;
    function bind() {
      document.querySelectorAll('.oryn-accordion__btn').forEach(function(btn) {
        if (btn._orynBound) return;
        btn._orynBound = true;
        btn.addEventListener('click', function() {
          var open  = btn.getAttribute('aria-expanded') === 'true';
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) panel.setAttribute('hidden','');
          else      panel.removeAttribute('hidden');
        });
      });
    }
    bind();
    document.addEventListener('shopify:section:load', bind);
  }

  /* ──────────────────────────────────────
     9. SMOOTH ANCHOR SCROLL
     Auto-applied to all <a href="#..."> links.
  ────────────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior:'smooth', block:'start' }); }
      });
    });
  }

  /* ──────────────────────────────────────
     10. HERO MOUSE PARALLAX
     Add id="oryn-hero" to hero section.
     Add id="oryn-hero-content" to the text content div inside.
     Text subtly tracks the mouse for a depth effect.
  ────────────────────────────────────── */
  function initHeroMouseParallax() {
    var hero    = document.getElementById('oryn-hero');
    var content = document.getElementById('oryn-hero-content');
    if (!hero || !content) return;

    hero.addEventListener('mousemove', function(e) {
      var cx = (e.clientX / hero.offsetWidth  - 0.5) * 16;
      var cy = (e.clientY / hero.offsetHeight - 0.5) * 9;
      content.style.transform  = 'translate(' + cx + 'px,' + cy + 'px)';
      content.style.transition = 'transform .15s ease';
    });
    hero.addEventListener('mouseleave', function() {
      content.style.transform  = 'translate(0,0)';
      content.style.transition = 'transform .8s ease';
    });
  }

  /* ── INIT ALL ── */
  function boot() {
    initLoader();
    initCursor();
    initReveal();
    initParallax();
    initCounters();
    initTilt();
    initStickyNav();
    initAccordion();
    initSmoothScroll();
    initHeroMouseParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init on Shopify section load (theme editor) */
  document.addEventListener('shopify:section:load', function() {
    initReveal(); initTilt(); initAccordion(); initCounters();
  });

  /* Expose for manual calls */
  window.OrynEffects = {
    initCursor: initCursor, initReveal: initReveal, initParallax: initParallax,
    initCounters: initCounters, initTilt: initTilt, initLoader: initLoader,
    initAccordion: initAccordion
  };

})();
